import { render, staticRenderFns } from "./edit-group.vue?vue&type=template&id=31ac35fa&scoped=true&"
import script from "./edit-group.vue?vue&type=script&lang=js&"
export * from "./edit-group.vue?vue&type=script&lang=js&"
import style0 from "./edit-group.vue?vue&type=style&index=0&id=31ac35fa&prod&lang=scss&scoped=true&"
import style1 from "./edit-group.vue?vue&type=style&index=1&id=31ac35fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac35fa",
  null
  
)

export default component.exports